import React, { useMemo } from 'react'
import { getOrganizationBlurb } from 'scenes/Dashboard/data/organizations/helpers'
import { Organization } from 'scenes/Dashboard/data/organizations/types'

import { Typography } from '@mui/material'

export type DealCardCompanyBlurbProps = {
  className?: string
  style?: React.CSSProperties
  organization: Organization
}

export const DealCardCompanyBlurb = React.memo(({ className, style, organization }: DealCardCompanyBlurbProps) => {
  const organizationBlurb = useMemo(() => getOrganizationBlurb(organization), [organization])
  return (
    <Typography variant="body2" className={className} style={style}>
      {organizationBlurb}
    </Typography>
  )
})

DealCardCompanyBlurb.displayName = 'DealCardCompanyBlurb'
